export default "__VITE_ASSET__25832043__"